/**
 * useCurrentUser — wraps useNostrLogin to provide the { user } shape
 * that Concord V2 hooks expect (NUser with signer).
 */

import { useNostrLogin, NUser } from "@nostrify/react/login";
import { useMemo } from "react";

export function useCurrentUser() {
  const { logins } = useNostrLogin();

  const user = useMemo(() => {
    const login = logins[0];
    if (!login) return undefined;

    // Map NostrLoginProvider's login to NUser with signer
    try {
      switch (login.type) {
        case "extension":
          return NUser.fromExtensionLogin(login);
        case "nsec":
          return NUser.fromNsecLogin(login);
        default:
          return undefined;
      }
    } catch {
      return undefined;
    }
  }, [logins]);

  return { user };
}